import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { Formik, FormikActions, FormikProps } from 'formik';
import { ValueType } from 'react-select/lib/types';
import { Log } from 'ng2-logger';
import * as Actions from '../../store/actions/general';
import * as Constants from '../../store/constants/all';
import * as Types from '../../store/types';
// dönem türleri sınav türlerinden alınmıştır
import { TermTypes } from '../../store/constants/exam-period-const';
import { routes as Routes } from '../../store/constants/routes';
import * as GT from '../../tools/general-tools';
import MultipleCheckbox from '../../components/checkboxes/multiple-checkbox';
import Spinner from '../../components/templates/spinner';
import MainLayout from '../layouts/main-layout';
import APlanHeader from '../../components/templates/aplan-header';
import SortedColumn from '../../components/table/sorted-column';
import Paginate from '../../components/table/paginate';
import Translator from '../../services/translate-factory';
import { EventPeriodSearchInitialValues } from '../../store/constants/event-period-const';
import EventPeriodForm from './event-period-form';
import Flatpickr from 'react-flatpickr';
import moment from 'moment';
import CopyEventPeriodForm from './event-copy-period-form';
import { MouseEventHandler } from 'react';
import { UserRole } from '../../store/constants/enums';
import Button from '../../components/button';

const T = Translator.create();
const L = Log.create('EventPeriodListPage');

class EventPeriodTable extends Component<Types.IEventPeriodPageProps, Types.IEventPeriodPageState> {
  state: Types.IEventPeriodPageState = {
    filters: EventPeriodSearchInitialValues,
    filterIsOpen: false,
    eventPeriodFormIsOpen: false,
    eventPeriodId: undefined,
    copyFormIsOpen: false,
    copyFormTermId: undefined,
    terms: [],
  };

  constructor(props: Types.IEventPeriodPageProps) {
    super(props);
    this.state.locale = GT.getLocaleFromLangCode();
    this.isSystem = this.isSystem.bind(this);
  }

  langChanged = () => {
    setTimeout(() => {
      try {
        this.forceUpdate();
      } catch (e) {
        L.error(e as string);
      }
    }, 1000);
  };

  componentDidMount() {
    T.removeListener(Constants.gen.CORE_CHANGE_LANGUAGE, this.langChanged);
    T.addListener(Constants.gen.CORE_CHANGE_LANGUAGE, this.langChanged);
    window.scrollTo(0, 0);
    this.getTermSelectOptions();
    this.searchEventPeriods();
    this.updateTermListForTermSelector();
  }

  componentWillUnmount() {
    T.removeListener(Constants.gen.CORE_CHANGE_LANGUAGE, this.langChanged);
  }

  getTermSelectOptions() {
    this.props.dispatch(Actions.ApiRequest(Constants.exam_period.EXAM_PERIOD_GET_SELECT_OPTIONS, 'event-period-spinner'));
  }

  updateTermListForTermSelector() {
    this.props.dispatch(Actions.ApiRequest(Constants.event_period.EVENT_PERIOD_GET_LIST, null, 'term-selector-spinner'));
  }

  searchEventPeriods() {
    this.props.dispatch(Actions.ApiRequest(Constants.event_period.EVENT_PERIOD_LIST_SEARCH, this.state.filters, 'examPeriod-list-spin'));
  }

  getSelectedPeriodInfo(term_id: number) {
    this.props.dispatch(Actions.ApiRequest(Constants.exam_period.EXAM_PERIOD_GET_PERIOD_DATES, term_id, 'exam-period-modal-tab-spin'));

    let model: Types.IFilterSolutionModel = {
      term_id: term_id,
      active_tab: '0',
      page: 1,
      total: -1,
      size: 10,
      solution_id: 0,
    };
    this.props.dispatch(Actions.ApiRequest(Constants.solution.SOLUTION_GET_BY_TERM, model, 'solution-schedule-spinner'));
  }

  sort = (sortkey: string, order_by: string) => {
    this.setState((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        order_by: sortkey + '_' + order_by,
      },
    }));
    this.searchEventPeriods();
  };

  eventPeriodFormIsOpen = () => {
    this.props.dispatch(Actions.Navigation(GT.Route(Routes.EVENT_PERIODS, '/create')));
  };

  copyFormIsOpen = (item: any) => {
    this.setState((prev) => ({
      ...prev,
      copyFormIsOpen: true,
      copyFormTermId: item.term_id,
    }));
  };

  eventPeriodFormOnClose = (refresh: boolean) => {
    if (this.state.eventPeriodFormIsOpen) {
      this.props.dispatch(Actions.Navigation(GT.Route(Routes.EVENT_PERIODS)));
    }
    if (refresh) {
      this.searchEventPeriods();
    }
  };

  copyFormOnClose = (refresh: boolean) => {
    if (this.state.copyFormIsOpen) {
      this.props.dispatch(Actions.Navigation(GT.Route(Routes.EVENT_PERIODS)));
    }
    if (refresh) {
      this.searchEventPeriods();
    }
    this.setState((prev) => ({
      ...prev,
      copyFormIsOpen: false,
    }));
  };

  calendarFormIsOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (e && e.currentTarget) {
      const id: string = e.currentTarget.dataset.id || '';
      this.setState((prev) => prev);
      this.props.dispatch(Actions.Navigation(GT.Route(Routes.EVENT_PERIODS, '/calendar/' + id)));
    }
  };

  calendarFormOnClose = () => {
    this.props.dispatch(Actions.Navigation(GT.Route(Routes.EVENT_PERIODS)));
  };

  onPageChange = (page: number, size?: number) => {
    this.setState(
      (prev) => ({
        ...prev,
        filters: {
          ...prev.filters,
          page: page,
          size: size ? size : 10,
        },
      }),
      this.searchEventPeriods,
    );
  };

  onSizeChange = (size: number) => {
    this.setState(
      (prev) => ({
        ...prev,
        filters: {
          ...prev.filters,
          size: size,
        },
      }),
      this.searchEventPeriods,
    );
  };

  onFormReset = () => {
    this.setState((prev) => ({
      ...prev,
      filters: Object.assign({}, EventPeriodSearchInitialValues),
    }));
    this.searchEventPeriods();
  };

  onFilterEventPeriod(model: Types.IFilterEventPeriod, FormActions: FormikActions<Types.IFilterEventPeriod>) {
    this.setState((prev) => ({
      ...prev,
      filters: {
        ...model,
        page: 1,
      },
      filterIsOpen: true,
    }));
    this.searchEventPeriods();
    FormActions.setSubmitting(false);
  }

  onEventPeriodEdit = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (e && e.currentTarget) {
      const id: string = e.currentTarget.dataset.id || '';
      this.props.dispatch(Actions.Navigation(GT.Route(Routes.EVENT_PERIODS, '/' + id)));
    }
  };

  onEventPeriodDelete = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (e && e.currentTarget.dataset && e.currentTarget.dataset.id) {
      let id = e.currentTarget.dataset.id;
      let name = e.currentTarget.dataset.name;
      const resultCallBack = () => {
        this.updateTermListForTermSelector();
      };
      const onConfirmDelete = () => {
        this.props.dispatch(Actions.ApiRequest(Constants.event_period.EVENT_PERIOD_DELETE, id, undefined, resultCallBack));
      };
      this.props.dispatch(
        Actions.ShowModal({
          title: T.t('gen_exam_will_be_deleted'),
          body: T.t('gen_are_you_sure_you_want_delete_period_named').replace('{0}', name),
          name: 'examPeriod_delete',
          icon: 'error_outline',
          iconColor: 'red',
          confirm: T.t('gen_yes'),
          cancel: T.t('gen_no'),
          onConfirm: onConfirmDelete,
        }),
      );
    }
  };

  static getDerivedStateFromProps(props: Types.IEventPeriodPageProps, state: Types.IEventPeriodPageState) {
    let hasNewState: boolean = false;

    if (props.terms) {
      state.terms = props.terms;
    }

    if (props.match && props.match.params.id) {
      let regexObject = props.location.pathname.match(/[^/]+$/);
      hasNewState = true;
      if (props.location && props.location.pathname.includes('calendar')) {
        // regexObject = props.location.pathname.match(/([^\/]+$)/); // gets the id of the calendar
        state.eventPeriodId = parseInt(regexObject[0], 10);
      } else if (props.location && regexObject[0] === 'create') {
        state.eventPeriodFormIsOpen = true;
      } else if (props.location && regexObject[0] !== 'create') {
        state.eventPeriodId = props.match.params.id;
        state.eventPeriodFormIsOpen = true;
      }
    } else {
      hasNewState = true;
      state.eventPeriodFormIsOpen = false;
      state.eventPeriodId = undefined;
    }
    if (hasNewState) {
      return state;
    } else {
      return null;
    }
  }

  onTermSelect = (term_id: any, term_type: any) => {
    this.props.synchronization && (this.props.synchronization.synctype_campus_clicked = false);
    this.props.synchronization && (this.props.synchronization.synctype_building_clicked = false);
    this.props.synchronization && (this.props.synchronization.synctype_classroom_clicked = false);
    this.props.synchronization && (this.props.synchronization.synctype_faculty_clicked = false);
    this.props.synchronization && (this.props.synchronization.synctype_program_clicked = false);
    this.props.synchronization && (this.props.synchronization.synctype_instructor_clicked = false);
    this.props.synchronization && (this.props.synchronization.synctype_course_clicked = false);
    this.props.synchronization && (this.props.synchronization.synctype_student_clicked = false);

    this.props.dispatch(Actions.SetTermInfo(term_id, term_type));
    this.props.dispatch(Actions.ApiRequest(Constants.disributor.GET_DISTRIBUTION_IN_PROGRESS_STATUS, term_id, 'ep-student-list'));
    this.props.dispatch(Actions.Navigation(Routes.EVENT_PERIODS));
    this.props.dispatch(Actions.Navigation(GT.Route(Routes.EVENT_PERIODS)));
    this.getSelectedPeriodInfo(term_id);
  };

  isSystem() {
    let authoritativeRoles: string[] = [UserRole.SYSTEM, UserRole.EVENT_MANAGER];
    return this.props.user && authoritativeRoles.includes(this.props.user.role);
  }

  AddButton() {
    return this.isSystem() ? (
      <button id="button_add_term" className="primary" onClick={this.eventPeriodFormIsOpen}>
        <i className="material-icons">add</i>
        {T.t('gen_add_event_term')}
      </button>
    ) : (
      <></>
    );
  }

  filterShow() {
    return this.state.filterIsOpen ? `show` : ``;
  }

  flatpickrOnChange(selectedDates: any, props: FormikProps<Types.IFilterEventPeriod>) {
    if (selectedDates.length === 2) {
      const startDate = moment(selectedDates[0]).format('YYYY-MM-DD');
      const endDate = moment(selectedDates[1]).format('YYYY-MM-DD');
      props.setFieldValue('time_range', { start: startDate, end: endDate });
      props.setFieldValue('start_date', startDate);
      props.setFieldValue('end_date', endDate);
    }
  }

  conditionalShow(condition: boolean | undefined, Component: any, elseComponent?: any) {
    if (condition) {
      return Component;
    } else {
      return elseComponent;
    }
  }

  itemStatusColor(item: Types.ITermItem) {
    return item.status == 1 ? ` co-green` : ` tag-red`;
  }

  getFlatpickrValue(values: Types.IFilterEventPeriod) {
    return values.time_range ? [moment(values.time_range.start).toDate(), moment(values.time_range.end).toDate()] : [];
  }

  getDefaultFlatpickrDate(values: Types.IFilterEventPeriod) {
    return values.time_range ? [moment(values.time_range.start).toDate(), moment(values.time_range.end).toDate()] : [];
  }

  render() {
    let eventPeriodList = this.props.results;
    return (
      <MainLayout header={<APlanHeader />}>
        <div className="main list-campus">
          <div className="container-fluid">
            <div className="row align-items-center mb-sm-4 mb-2">
              <div className="col-md-6 col-sm-4 col-12">
                <h4 className="mb-4 mb-sm-0">{T.t('gen_event_terms')}</h4>
              </div>
              <div className="col-md-6 col-sm-8 col-12 text-right">
                <div className="options align-items-center with-gap right">
                  <button
                    id="button_filter"
                    className="ghost"
                    onClick={() => {
                      this.setState((prev) => ({
                        ...prev,
                        filterIsOpen: !prev.filterIsOpen,
                      }));
                    }}
                  >
                    <i className="material-icons">filter_list</i>
                    <span>{T.t('gen_filter')}</span>
                  </button>
                  <AddButton isSystem={this.isSystem} eventPeriodFormIsOpen={this.eventPeriodFormIsOpen} />
                </div>
              </div>
            </div>
            <div className={`white-container mt-4 collapse ` + this.filterShow()} id="advance-search">
              <div className="advance-search d-block mt-3">
                <Formik
                  initialValues={EventPeriodSearchInitialValues}
                  enableReinitialize={true}
                  onSubmit={(values, actions) => {
                    this.onFilterEventPeriod(values, actions);
                  }}
                  onReset={this.onFormReset}
                >
                  {(props: FormikProps<Types.IFilterEventPeriod>) => {
                    const { values } = props;
                    return (
                      <form onSubmit={props.handleSubmit}>
                        <div className="row">
                          <div className="col-12">
                            <h6>{T.t('gen_filter_parameters')}</h6>
                          </div>
                          <div className="col-md-2">
                            <div className="form-input form-group date-picker">
                              <input
                                id="name"
                                name="name"
                                value={props.values.name}
                                onChange={props.handleChange}
                                type="text"
                                required={false}
                              />
                              <span className="highlight" />
                              <span className="bar" />
                              <label htmlFor="name">{T.t('gen_term_name')}</label>
                              <i className="material-icons">title</i>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-input form-group date-picker">
                              <input id="year" name="year" value={props.values.year} onChange={props.handleChange} type="number" />
                              <span className="highlight" />
                              <span className="bar" />
                              <label htmlFor="year">{T.t('gen_year')}</label>
                            </div>
                          </div>
                          <div className="col-md-4 form-input">
                            <div className="react-select-container">
                              <h6>{T.t('gen_terms')}</h6>
                              <Select
                                id="select_term"
                                className="react-select"
                                isMulti={true}
                                filterOption={(option: any, query: any) =>
                                  option.label
                                    .toLocaleLowerCase(T.getSelectedLanguage())
                                    .includes(query.toLocaleLowerCase(T.getSelectedLanguage()))
                                }
                                closeMenuOnSelect={false}
                                options={TermTypes(T)}
                                placeholder={T.t('gen_select_term')}
                                value={props.values.academic_terms}
                                onChange={(options: ValueType<Types.ISelectOption> | ValueType<Types.ISelectOption[]>) => {
                                  const list: Array<Types.ISelectOption> = (options as Array<Types.ISelectOption>) || []; //empty

                                  props.setFieldValue('academic_terms', list);
                                  props.setFieldValue(
                                    'academic_term_ids',
                                    list.map((item) => item.value),
                                  );
                                }}
                                noOptionsMessage={(): string => T.t('gen_select_no_term')}
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="react-select-container">
                              <label>{T.t('gen_exam_and_course_solutions')}</label>
                              <Select
                                className="react-select"
                                placeholder={T.t('gen_select_exam_and_course_solutions')}
                                noOptionsMessage={(): string => T.t('gen_select_no_term')}
                                filterOption={(option: any, query: any) =>
                                  option.label
                                    .toLocaleLowerCase(T.getSelectedLanguage())
                                    .includes(query.toLocaleLowerCase(T.getSelectedLanguage()))
                                }
                                options={this.props.selectOptions && this.props.selectOptions.connected_solutions}
                                isMulti={true}
                                closeMenuOnSelect={false}
                                value={props.values.connected_solutions ? props.values.connected_solutions : null}
                                onChange={(options: ValueType<Types.ISelectOption> | ValueType<Types.ISelectOption[]>) => {
                                  const list: Array<Types.ISelectOption> = options ? (options as Array<Types.ISelectOption>) : [];
                                  props.setFieldValue('connected_solutions', list);
                                  props.setFieldValue(
                                    'connected_solution_ids',
                                    list.map((item) => item.value),
                                  );
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-4 form-input form-group with-icon">
                            <Flatpickr
                              placeholder={T.t('gen_select_dates')}
                              value={this.getFlatpickrValue(values)}
                              options={{
                                dateFormat: 'd.m.Y',
                                mode: 'range',
                                locale: this.state.locale,
                                defaultDate: this.getDefaultFlatpickrDate(values),
                              }}
                              onChange={(selectedOptions) => this.flatpickrOnChange(selectedOptions, props)}
                            />
                            <span className="highlight" />
                            <span className="bar" />
                            <label htmlFor="term_date_range">{T.t('gen_start_and_end_dates')}</label>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-6">
                            <div className="text-left">
                              <h6>{T.t('gen_status')}</h6>
                              <div className="tick-radio position-relative mb-3 d-inline-block">
                                <MultipleCheckbox name="status" text={T.t('gen_active')} value={1} />
                              </div>
                              <div className="tick-radio position-relative mb-3 d-inline-block ml-4">
                                <MultipleCheckbox name="status" text={T.t('gen_passive')} value={0} />
                              </div>
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div className="row mt-3">
                          <div className="col-6 with-gap">
                            <button
                              id="button_arrow_upward"
                              type="button"
                              onClick={() => {
                                this.setState((prev) => ({
                                  ...prev,
                                  filterIsOpen: false,
                                }));
                              }}
                              className="ghost"
                            >
                              <i className="material-icons">arrow_upward</i>
                            </button>
                            <button id="button_delete_sweep" type="reset" onClick={props.handleReset} className="danger">
                              <i className="material-icons">delete_sweep</i>
                            </button>
                          </div>
                          <div className="col-6 with-gap right">
                            <button
                              id="button_search"
                              type="button"
                              className="secondary xl"
                              onClick={() => props.handleSubmit()}
                              disabled={props.isSubmitting}
                            >
                              <i className="material-icons mr-2">search</i> {T.t('gen_search')}
                            </button>
                          </div>
                        </div>
                      </form>
                    );
                  }}
                </Formik>
              </div>
            </div>
            <Spinner name="examPeriod-list-spin" />
            <div className="white-container mt-4">
              <div className="row">
                <div className="col-12">
                  <table className="aplan-table aplan-table-responsive table table-borderless table-striped table-hover sortable filter-table">
                    <thead>
                      <tr>
                        <SortedColumn
                          datacell="status"
                          title={T.t('gen_status')}
                          sortkey="status"
                          sortedcolumn={this.state.filters.order_by}
                          sort={this.sort}
                          style={{ width: '8%' }}
                        />
                        <SortedColumn datacell="id" title="ID" sortkey="id" sortedcolumn={this.state.filters.order_by} sort={this.sort} />
                        <SortedColumn
                          datacell="year"
                          className="d-none d-lg-table-cell d-xl-table-cell"
                          title={T.t('gen_year')}
                          sortkey="year"
                          sortedcolumn={this.state.filters.order_by}
                          sort={this.sort}
                        />
                        <SortedColumn
                          datacell="academic_term"
                          className="d-none d-lg-table-cell d-xl-table-cell"
                          title={T.t('gen_terms')}
                          sortkey="academic_term"
                          sortedcolumn={this.state.filters.order_by}
                          sort={this.sort}
                        />
                        <SortedColumn
                          datacell="name"
                          className="d-none d-lg-table-cell d-xl-table-cell"
                          title={T.t('gen_name')}
                          sortkey="name"
                          sortedcolumn={this.state.filters.order_by}
                          sort={this.sort}
                        />
                        <th scope="col" className="text-center">
                          {T.t('gen_time_range')}
                        </th>
                        <th scope="col" className="text-center">
                          {T.t('gen_description')}
                        </th>
                        {this.isSystem() ? (
                          <>
                            <th scope="col" className="text-center">
                              {T.t('gen_sketch_count')}
                            </th>
                            <th scope="col" className="text-center">
                              {T.t('gen_image_count')}
                            </th>
                            <th scope="col" className="text-center">
                              {T.t('gen_event_count')}
                            </th>
                          </>
                        ) : null}
                        <th scope="col" className="text-center">
                          {T.t('gen_select_term')}
                        </th>
                        {this.isSystem() ? (
                          <th scope="col" className="text-right">
                            <span className="text-right">{T.t('gen_actions')}</span>
                          </th>
                        ) : null}
                      </tr>
                    </thead>
                    <tbody>
                      {eventPeriodList && eventPeriodList.length
                        ? eventPeriodList.map((item: Types.ITermItem) => {
                            let termsObjects = TermTypes(T).filter(
                              (object) => item.academic_terms && item.academic_terms.includes(object.value),
                            );
                            return (
                              <tr key={'examPeriod-' + item.term_id} data-title={item.name}>
                                <td className="text-center" scope="row" data-label={T.t('gen_status')} style={{ width: '8%' }}>
                                  <div className="tags ml-1 mr-4">
                                    <button id="button_status" className={`tw-p-1 small-tag text-uppercase ` + this.itemStatusColor(item)}>
                                      {GT.GetActiveStatus(item.status)}
                                    </button>
                                  </div>
                                </td>
                                <td scope="row" data-label="ID">
                                  {item.term_id}
                                </td>
                                <td data-label={T.t('gen_year')}>{item.year}</td>
                                <td data-label={T.t('gen_terms')}>
                                  {termsObjects && termsObjects.map((termObject) => termObject.label).join(', ')}
                                </td>

                                <td data-label={T.t('gen_name')}>{item.name}</td>
                                <td data-label={T.t('gen_time_range')} className="text-center">
                                  {item.time_range
                                    ? `${moment(item.time_range.start).format('DD.MM.YYYY')} - ${moment(item.time_range.end).format('DD.MM.YYYY')}`
                                    : '-'}
                                </td>
                                <td data-label={T.t('gen_description')} className="text-center">
                                  {item.description && item.description.length ? (
                                    <div className="table-scrollable-td">{item.description}</div>
                                  ) : (
                                    '-'
                                  )}
                                </td>
                                {this.isSystem() ? (
                                  <React.Fragment>
                                    <td data-label={T.t('gen_sketch_count')} className="text-center">
                                      {item.sketch_count}
                                    </td>
                                    <td data-label={T.t('gen_image_count')} className="text-center">
                                      {item.photo_count}
                                    </td>
                                    <td data-label={T.t('gen_event_count')} className="text-center">
                                      {item.event_count}
                                    </td>
                                  </React.Fragment>
                                ) : null}
                                <td data-cell="exam-periods" className="text-center">
                                  <Button
                                    size="disable"
                                    id="button_term_type"
                                    className="glyph xs aplan"
                                    onClick={() => this.onTermSelect(item.term_id, item.term_type)}
                                    icon="external-link"
                                    iconPosition="right"
                                  >
                                    {item.name}
                                  </Button>
                                </td>
                                {this.conditionalShow(
                                  this.isSystem(),
                                  <td data-label={T.t('gen_actions')} className="table-buttons">
                                    <div className="table-buttons-wrapper">
                                      <button
                                        id="button_edit"
                                        data-toggle="tooltip"
                                        data-id={item.term_id}
                                        onClick={this.onEventPeriodEdit}
                                        title={T.t('gen_edit')}
                                        className="ghost square btn-sm table-button"
                                      >
                                        <span className="d-block" data-toggle="modal" data-target="#addNew">
                                          <i className="material-icons">edit</i>
                                        </span>
                                      </button>
                                      <button
                                        id="button_delete"
                                        data-toggle="tooltip"
                                        data-id={item.term_id}
                                        data-name={item.name}
                                        onClick={this.onEventPeriodDelete}
                                        title={T.t('gen_delete')}
                                        className="ghost square btn-sm table-button"
                                      >
                                        <span className="d-block" data-toggle="modal" data-target="#exampleModal">
                                          <i className="material-icons">delete</i>
                                        </span>
                                      </button>
                                    </div>
                                  </td>,
                                )}
                              </tr>
                            );
                          })
                        : null}
                    </tbody>
                  </table>
                  <div className="row-options justify-content-end">
                    <div className="page-sorting d-flex align-items-center justify-content-center" style={{ marginTop: '5px' }}>
                      {this.props.results && this.props.results.length > 0 && (
                        <Paginate filters={this.props.filters} onPageChange={this.onPageChange} onSizeChange={this.onSizeChange} />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.copyFormIsOpen && (
          <CopyEventPeriodForm
            examPeriodId={this.state.copyFormTermId}
            formIsOpen={this.state.copyFormIsOpen}
            onClose={this.copyFormOnClose}
          />
        )}
        <EventPeriodForm
          eventPeriodId={this.state.eventPeriodId}
          formIsOpen={this.state.eventPeriodFormIsOpen}
          onClose={this.eventPeriodFormOnClose}
        />
      </MainLayout>
    );
  }
}

const AddButton = ({
  isSystem,
  eventPeriodFormIsOpen,
}: {
  isSystem: () => boolean | undefined;
  eventPeriodFormIsOpen: MouseEventHandler<HTMLButtonElement>;
}) => {
  return isSystem() ? (
    <button id="button_add_term" className="primary" onClick={eventPeriodFormIsOpen}>
      <i className="material-icons">add</i>
      {T.t('gen_add_event_term')}
    </button>
  ) : (
    <></>
  );
};

const mapStateToProps = (store: Types.IPersistedState, ownProps: Types.IEventPeriodPageProps): Types.IEventPeriodPageProps => {
  if (!store) {
    return ownProps;
  }

  const newProps: Types.IEventPeriodPageProps = Object.assign({}, ownProps, {
    results: store.state.event_period_page && store.state.event_period_page.results,
    filters: store.state.event_period_page && store.state.event_period_page.filters,
    user: store.state.user,
    synchronization: store.state.synchronization && store.state.synchronization,
    selectOptions: store.state.select_options && store.state.select_options.termsPage,
    terms: store.state.term_list,
    term_id: store.state.term_id,
  });
  return newProps;
};

const equal = require('deep-equal');
const areStatesEqual = (next: Types.IPersistedState, prev: Types.IPersistedState) => {
  return false;
};

const dispatchProps = (dispatch: any) => ({ dispatch });

const container = connect(mapStateToProps, dispatchProps, null, {
  areStatesEqual,
})(EventPeriodTable);

export default container;
